import { defineStyleConfig as o } from "@chakra-ui/react";
import { ThemeColorToken as r } from "../theme-tokens.js";
const e = {
  borderColor: r.OnBackgroundBorder,
  m: 0,
  opacity: 1
}, t = o({
  baseStyle: e
});
export {
  t as dividerConfig
};
